import styled from 'styled-components';

import { Multiselect } from '@dreryk/react-components';

export const StyledPractitionersMultiselect = styled(Multiselect)`
   width: 300px;
` as typeof Multiselect;
